"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _isArray = _interopRequireDefault(require("lodash/isArray"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _filterContext = _interopRequireDefault(require("../context/filterContext"));
var _useFilterAPI = _interopRequireDefault(require("../hooks/useFilterAPI"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Filter = _ref => {
  let {
    api,
    children,
    excludedFilter = [],
    filterOnChange = false,
    handleOnSubmit,
    lang = "de",
    localValues,
    preSelectedValues,
    refForm,
    selectedFilter = [],
    setLocalValues
  } = _ref;
  const defaultFilter = (0, _useFilterAPI.default)({
    api,
    lang,
    ...localValues
  });
  const handleChange = (identifier, value, resetAll) => {
    const tmpLocalValues = JSON.parse(JSON.stringify(localValues));
    const tmpValue = tmpLocalValues?.[identifier] ?? [];
    if ((0, _isArray.default)(tmpValue)) {
      const index = tmpValue?.indexOf(value);
      if (index > -1) {
        tmpValue.splice(index, 1);
      } else {
        tmpValue.push(value);
      }
    }
    if (resetAll) {
      tmpLocalValues[identifier] = [];
    } else {
      tmpLocalValues[identifier] = tmpValue;
    }
    setLocalValues(tmpLocalValues);
    if (filterOnChange) {
      setTimeout(() => {
        const evt = new CustomEvent("submit", {
          bubbles: true,
          cancelable: true
        });
        refForm.current.dispatchEvent(evt);
      }, 10);
    }
  };
  const selectedFilterOptions = (0, _react.useMemo)(() => {
    if (!(0, _isEmpty.default)(selectedFilter)) return selectedFilter;
    const options = [];
    for (const key in defaultFilter) {
      const {
        type
      } = defaultFilter[key] || {};
      if (type === "checkbox" && excludedFilter.indexOf(key) === -1) options.push(key);
    }
    return options;
  }, [defaultFilter, excludedFilter, selectedFilter]);
  return /*#__PURE__*/_react.default.createElement("form", {
    className: "mco-filter",
    ref: refForm,
    onSubmit: e => {
      if (handleOnSubmit) {
        handleOnSubmit(e);
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_filterContext.default.Provider, {
    value: {
      defaultFilter,
      localValues,
      preSelectedValues,
      selectedFilter: selectedFilterOptions,
      setLocalValues,
      onChange: handleChange
    }
  }, children));
};
var _default = exports.default = Filter;